// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".city-select[data-v-11542ebe] .el-cascader {\n  width: 100%;\n}\n.city-select[data-v-11542ebe] .el-cascader .el-cascader__tags .el-cascader__search-input {\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
